import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
/*

 * @Date: 2022-11-20 20:08:15
 * @LastEditTime: 2023-06-15 16:48:52
 * @FilePath: \hexasino-platform-pc\src\utils\svgInstall.js
 * @Description: 循环全局注册的svg组件, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
var importComponentsFn = require.context('../assets/iconSvg', false, /\.svg$/);
export default {
  install: function install(vue) {
    // importComponentsFn.keys()获取所有.svg后缀的文件名数组循环
    importComponentsFn.keys().forEach(function (element) {
      var componentName = element.replace(/\.\//, '').replace(/\.svg$/, '');
      // importComponentsFn传入文件名，批量导入组件.default获取组件信息
      var getComponents = importComponentsFn(element);

      // 使用组件名进行注册组件
      vue.component(componentName, getComponents);
    });
  }
};